import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import {
  getDeviceStatusTextArray,
  statusTextToTypeMap,
} from '../../utils/textMappings';
import { StatusDropDownFilterCell } from './StatusDropDownFilterCell';
import { GetString } from '../StringResourceManager';

export const StatusFilterCell: any = (props: GridCustomFilterCellProps) => (
  <StatusDropDownFilterCell
    {...props}
    data={getDeviceStatusTextArray()}
    defaultItem={GetString('ALL')}
    onChangeValueCheckFunc={statusTextToTypeMap}
  />
);
